import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Breadcrumb } from '../../../../models/shared/stylesheet/breadcrumb';

@Component({
  selector: 'app-employer-logo-header',
  templateUrl: './employer-logo-header.component.html',
  styleUrls: ['./employer-logo-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerLogoHeaderComponent {
  @Input() breadcrumbs: Breadcrumb[] | null = null;
  @Input() headerTitle: string | null = null;
  @Input() employerLogoSrc: string | null = null;
  @Input() isLoading: boolean | null = false;
}
